<app-patient-search
  class="mb-10"
  [search]="searchCriteria"
  [list]="patientList"
  [refreshTime]="refreshTime"
  [hideAfter]="hidePatientSearch"
  (onActionClick)="patientOnSelect($event)"
></app-patient-search>
<div class="patient-detail fixed-height">
  <div class="flex">
    <div class="col-8">
      <div *ngIf="patientInfoDisplay" style="width:180vh">
        <img
          [style.width]="'30px'"
          [src]="patientImage ? patientImage : './assets/images/user.png'"
        />
        <label class="patient-name-label"> {{ patientInfoDisplay }}</label>
      </div>
      <div *ngIf="!patientInfoDisplay">
        <label class="patient-name-label">{{
          "RegistrationPage.noPatient" | translate
        }}</label>
      </div>
    </div>
    <div class="col-4 right">
      <button
        id="Add Patient"
        class="btnCyan"
        (click)="addSecondaryDetails()"
        mat-mini-fab
        matTooltip="{{ 'payerInfo.addsecondarypatient' | translate }}"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
</div>
<div style="height: 34pc">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    class="mat-header mat-elevation-z8"
  >
    <!-- Radio Buttons Column -->
    <ng-container matColumnDef="radio">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let row">
        <mat-radio-group
          aria-labelledby="example-radio-group-label"
          class="example-radio-group"
          [(ngModel)]="selectedPerson"
        >
          <mat-radio-button
            [value]="row"
            (click)="selectedRow(row)"
          ></mat-radio-button>
        </mat-radio-group>
      </td>
    </ng-container>

    <!-- MRN Column -->
    <ng-container matColumnDef="mrn">
      <th mat-header-cell *matHeaderCellDef>MRN</th>
      <td mat-cell *matCellDef="let element">
        <strong class="name-container">{{ element.mrn }}</strong></td>
    </ng-container>

    <!-- Patient Details Column -->
    <ng-container matColumnDef="patientDetails">
      <th mat-header-cell *matHeaderCellDef>
        {{ "billing.patientDetails" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong class="name-container">{{ element.firstName }}</strong></td>
    </ng-container>

    <ng-container matColumnDef="dob">
      <th mat-header-cell *matHeaderCellDef>
        {{ "EncounterPage.DOBGender" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong class="name-container">{{ element.dob  }} / {{ generalApiService.getGender(element.gender) }}</strong></td>
      </ng-container>

    <ng-container matColumnDef="age">
      <th mat-header-cell *matHeaderCellDef>MRN</th>
      <td mat-cell *matCellDef="let element">
        <strong class="name-container">{{ generalApiService.calculateAge(element.dob) }}</strong></td>
    </ng-container>
    <!-- Identification Type Column      Identification Type -->
    <ng-container matColumnDef="idtype">
      <th mat-header-cell *matHeaderCellDef>
        {{ "RegistrationPage.primaryID" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong class="name-container">{{ element.primaryIDdesc }}</strong></td>
    </ng-container>

    <!-- Identification Number Column    Identification Number-->
    <ng-container matColumnDef="idnumber">
      <th mat-header-cell *matHeaderCellDef>
        {{ "RegistrationPage.primaryDocNo" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong class="name-container">{{ element.primaryId }}</strong></td>
    </ng-container>

    <!-- Contact Number Column Contact Number-->
    <ng-container matColumnDef="mobileno">
      <th mat-header-cell *matHeaderCellDef>
        {{ "billing.contactNumber" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <strong class="name-container">{{ element.phoneNumber }}</strong></td>
    </ng-container>

    <!-- status Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        {{ "EncounterListPage.action" | translate }}
      </th>
      <td mat-cell *matCellDef="let element; let index = index">
        <mat-icon
          (click)="removePatient(element)"
          matTooltip="{{ 'payerInfo.delete' | translate }}"
          >delete</mat-icon
        >
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<div class="modal-footer modalFooterAddItem">
  <mat-form-field
    class="fieldBoxwidth"
    style="padding-top: 10px; padding-bottom: 5px; padding-left: 20px"
    appearance="outline"
  >
    <mat-label>{{ "payerInfo.reason" | translate }}</mat-label>
    <mat-select [(ngModel)]="reason" name="reason" [required]="true">
      <mat-option>
        <ngx-mat-select-search
          [formControl]="reasonSearch"
          [placeholderLabel]="'reason'"
        ></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let reasons of reasonSample" [value]="reasons.code">
        {{ reasons.desc }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field
    style="padding-top: 10px; padding-bottom: 5px; padding-left: 20px"
    class="fieldBoxwidth"
    appearance="outline"
  >
    <mat-label>{{ "EncounterListPage.remarks" | translate }}</mat-label>
    <input
      matInput
      [placeholder]="'EncounterListPage.remarks' | translate"
      [(ngModel)]="remarks"
      name="remarks"
    />
  </mat-form-field>
  &nbsp;
  <button (click)="mergePatient()" class="btnCyan right" mat-mini-fab matTooltip="{{ 'payerInfo.save' | translate }}">
    <mat-icon>sim_card</mat-icon>
  </button>
</div>